export default {
invoice_history: "سجل الفواتير",
search_invoice: "ابحث عن الفاتورة / الطلب / المطعم...",
from: "من",
to: "إلى",
invoice_id: "رقم الفاتورة",
order_id: "رقم الطلب",
restaurant: "المطعم",
date: "التاريخ",
total: "الإجمالي",
status: "الحالة",
action: "الإجراء",
view: "عرض",
no_invoices: "لا توجد فواتير",

generated: "تم الإنشاء",
unpaid: "غير مدفوع",
paid: "مدفوع",
invoice_details: "تفاصيل الفاتورة",
supplier_details: "تفاصيل المورد",
restaurant_details: "تفاصيل المطعم",
products: "المنتجات",
payment_details: "تفاصيل الدفع",
download_pdf: "تحميل الفاتورة PDF",
pdf_error: "فشل تحميل الفاتورة",
store: "المتجر",
contact: "جهة الاتصال",
mobile: "الهاتف",
email: "البريد الإلكتروني",
address: "العنوان",
name: "الاسم",
qty: "الكمية",
price: "السعر",
discount: "الخصم",
}